import React, { useRef, useState, useEffect } from "react";
import "../../../styles/utils/loading/Loading.scss";
import ProgressBar from "../ProgressBar";
import OngoingModal from "../modal/OngoingModal";
import { useSoundContext } from "../../../SoundContext";
import MusicToggleButton from "../../utils/button/MusicToggleButton";
import useAppTranslation from "../../../hooks/useAppTranslation";

const Loading = ({ title, flag, end, onEnd }) => {
  const { t, i18n, language } = useAppTranslation("components/utils/loading");
  const [loadingMessages, setLoadingMessages] = useState([]);
  const remainingText = t("remainingSeconds", { seconds: 60 });
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isBackgroundImageChanged, setIsBackgroundImageChanged] =
    useState(false); //NOTE: completed되면 배경 변함
  const [countDown, setCountDown] = useState(30);
  const [isPlaying, setIsPlaying] = useState(true);
  // 2024-02-16 | OngoingModal
  const [showOngoingModal, setShowOngoingModal] = useState(false);
  const { isMuted } = useSoundContext();

  // 오디오 요소에 대한 참조 생성
  const audioRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleProgressComplete = () => {
    // setIsBackgroundImageChanged(true);
  };

  console.log(title);
  console.log(flag);

  console.log("end? =>", end);
  console.log(isBackgroundImageChanged);

  useEffect(() => {
    if (end) {
      setIsBackgroundImageChanged(true);
      const interval = setInterval(() => {
        onEnd();
      }, 3000);

      return () => {
        clearInterval(interval);
      };
    } else {
      setIsBackgroundImageChanged(false);
    }
  }, [end, onEnd]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    if (countDown === 0) {
      clearInterval(interval);
      setShowOngoingModal(true);
    }

    return () => clearInterval(interval);
  }, [countDown]);

  useEffect(() => {
    if (loadingMessages.length === 0) return undefined;

    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) =>
        prevIndex === loadingMessages.length - 1 ? 0 : prevIndex + 1,
      );
    }, 4000);

    return () => {
      clearInterval(interval);
      // clearTimeout(modalTimeout);
    };
  }, [loadingMessages.length]);

  useEffect(() => {
    const syncMessages = () => {
      const messages = i18n.getResource(
        i18n.language,
        "components/utils/loading",
        "messages",
      );

      if (Array.isArray(messages)) {
        setLoadingMessages(messages);
        setCurrentTextIndex(0);
      }
    };

    syncMessages();
    i18n.loadNamespaces("components/utils/loading").then(syncMessages);
    i18n.on("languageChanged", syncMessages);
    i18n.on("loaded", syncMessages);

    return () => {
      i18n.off("languageChanged", syncMessages);
      i18n.off("loaded", syncMessages);
    };
  }, [i18n, language]);

  useEffect(() => {
    if (!isBackgroundImageChanged && audioRef.current) {
      audioRef.current.volume = 0.2; // 볼륨을 50%로 설정
      audioRef.current.play().catch((error) => {
        console.error("오디오 재생에 실패했습니다.", error);
      });
    }

    // 로딩이 끝나면 오디오 정지
    if (isBackgroundImageChanged && audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // 오디오 시작 지점으로 재설정
    }
  }, [isBackgroundImageChanged]);

  // 2024-01-24 | handleAudioPlay 함수 수정
  const handleAudioPlay = () => {
    // audioRef.current.pause();
    //NOTE: 2024-01-23 수정 오디오 on/off 활성화
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    if (audioRef.current) {
      if (!isMuted && !isBackgroundImageChanged) {
        const audio = audioRef.current;
        audio.volume = 0;

        const fadeDuration = 2000;
        const steps = 20;
        const intervalTime = fadeDuration / steps;
        const targetVolume = 0.15;

        let currentStep = 0;

        audio.play().catch((error) => {
          console.error("오디오 재생에 실패했습니다.", error);
        });

        const fadeInterval = setInterval(() => {
          currentStep++;
          const newVolume = (targetVolume / steps) * currentStep;
          audio.volume = Math.min(newVolume, targetVolume);

          if (currentStep >= steps) {
            clearInterval(fadeInterval);
            audio.volume = targetVolume;
          }
        }, intervalTime);

        return () => clearInterval(fadeInterval);
      } else {
        audioRef.current.pause();
      }
    }
  }, [isMuted, isBackgroundImageChanged]);

  return (
    <>
      <section
        class={`loading-section ${
          isBackgroundImageChanged ? "background-changed" : ""
        }`}
      >
        <div className="music-toggle-btn-loading-wrapper">
          <MusicToggleButton />
        </div>
        <div className="loading-bar-container">
          <audio ref={audioRef} src="/audio/AIMagickid.mp3" loop />
          {flag === "story" && (
            <>
              <h3 className={`loading-title`}>
                {title.story} ☻ <span>{remainingText}</span>
              </h3>
              <h3 className={`loading-title-sub on`}>
                {title.bg} ☻ <span>{remainingText}</span>
              </h3>
            </>
          )}

          {flag === "bg" && (
            <>
              <h3 className={`loading-title on`}>
                {title.story} ☻ <span>{remainingText}</span>
              </h3>
              <h3 className={`loading-title-sub`}>
                {title.bg} ☻ <span>{remainingText}</span>
              </h3>
            </>
          )}

          {flag === "title" && (
            <h3
              className={`loading-title ${
                isBackgroundImageChanged ? "black" : ""
              }`}
            >
              {title} ☻
            </h3>
          )}

          <p class={`sub-txt ${isBackgroundImageChanged ? "none" : ""}`}>
            {loadingMessages[currentTextIndex] ?? ""}
          </p>
          <ProgressBar end={end} onProgressComplete={handleProgressComplete} />
        </div>

        <div class={`left-top ${isBackgroundImageChanged ? "none" : ""}`}>
          <img src="../images/utils/loading/left-top.svg" alt="" />
        </div>
        <div class={`right-top ${isBackgroundImageChanged ? "none" : ""}`}>
          <img src="../images/utils/loading/right-top.svg" alt="" />
        </div>
        <div class={`star-light ${isBackgroundImageChanged ? "none" : ""}`}>
          <img src="../images/utils/loading/star-light.svg" alt="" />
        </div>

        <div class="star-1">
          <img src="../images/utils/loading/star.svg" alt="" />
        </div>
        <div class="star-2">
          <img src="../images/utils/loading/star.svg" alt="" />
        </div>
        <div class="star-3">
          <img src="../images/utils/loading/star.svg" alt="" />
        </div>
        <div className="clock">
          <span className="time-label">{t("timeRemaining")}</span>
          <figure>
            <img src={"/images/utils/clock.svg"} alt={t("alts.clock")} />
          </figure>
          <p className={`count-down ${countDown <= 10 ? "red" : ""}`}>
            {countDown}
          </p>
        </div>

        <div class="witch">
          <svg
            className="witch-svg"
            width="880"
            height="925"
            viewBox="0 0 1053 925"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M893.589 343.15C891.67 358.984 889.796 375.126 892.287 391.004C894.294 403.905 899.587 415.879 907.768 426.023C923.183 445.142 946.713 456.565 970.154 462.343C983.253 465.585 997.036 467.437 1010.53 466.533C1017.3 466.07 1024.07 464.879 1030.47 462.586C1036.86 460.292 1043.17 457.095 1047.76 452.243C1049.92 449.95 1051.57 447.193 1051.99 444.04C1052.45 440.688 1051.48 437.358 1049.9 434.425C1046.72 428.625 1041.21 424.149 1035.78 420.576C1024.65 413.233 1011.39 409.616 998.161 408.668C967.177 406.463 938.046 419.54 910.084 431.117C895.243 437.27 880.181 443.18 864.457 446.576C856.563 448.296 848.492 449.354 840.398 449.398C833.011 449.421 825.337 448.45 818.853 444.679C813.252 441.416 808.687 435.638 807.849 429.11C807.011 422.583 810.275 416.982 815.501 413.541C828.071 405.272 842.89 411.932 853.894 419.628C874.866 434.315 891.295 455.088 901.88 478.309C912.465 501.53 917.207 527.089 915.178 552.383C913.127 577.743 904.108 604.735 884.547 622.002C879.916 626.104 874.69 629.478 869.044 632.036C867.743 632.609 868.868 634.528 870.147 633.932C894.162 623.082 908.209 597.987 914.097 573.288C919.985 548.634 918.75 522.48 911.627 498.2C904.505 473.921 891.472 451.317 873.587 433.366C869.111 428.868 864.347 424.7 859.297 420.863C853.564 416.496 847.499 412.417 840.729 409.837C834.488 407.477 827.63 406.595 821.147 408.491C815.656 410.123 810.451 413.586 807.629 418.68C804.674 424.06 805.004 430.411 807.651 435.858C810.517 441.746 815.7 446.047 821.698 448.494C828.512 451.295 836.076 451.78 843.375 451.515C851.38 451.207 859.319 450.016 867.104 448.208C898.617 440.908 926.844 424.127 957.937 415.526C984.51 408.183 1016.22 407.433 1038.89 425.538C1044.05 429.662 1050.18 435.594 1049.85 442.805C1049.52 450.016 1042.02 454.603 1036.33 457.558C1023.63 464.174 1008.81 465.232 994.765 464.129C969.713 462.145 943.868 453.985 923.8 438.549C914.163 431.139 905.938 421.789 900.601 410.829C893.875 397.046 892.662 381.566 893.456 366.46C893.875 358.653 894.779 350.891 895.728 343.128C895.904 341.717 893.699 341.739 893.522 343.128L893.589 343.15Z"
              fill="#7055E6"
            />
            <path
              d="M151.835 346.765C140.015 370.67 125.549 394.045 104.555 410.981C86.0088 425.933 61.244 436.474 37.0967 432.019C26.7762 430.101 16.6542 425.514 9.72977 417.398C2.80535 409.283 -0.21582 397.794 4.15054 387.936C6.39988 382.864 10.678 379.16 16.0588 377.682C22.0791 376.028 28.5404 377.065 34.4063 378.829C46.5351 382.468 57.9361 389.061 68.5433 395.853C90.1546 409.746 109.583 426.837 131.789 439.826C142.749 446.243 154.746 451.844 167.602 452.66C173.689 453.035 179.841 452.175 185.421 449.639C190.118 447.522 196.403 442.736 193.47 436.849C192.235 434.379 189.897 432.262 187.824 430.497C185.751 428.733 183.48 427.19 181.076 425.889C176.225 423.264 170.866 421.655 165.419 420.971C154.084 419.537 142.683 422.316 133.024 428.358C123.365 434.401 115.338 443.597 109.891 453.807C103.518 465.737 100.475 479.167 99.3504 492.575C98.1596 506.688 98.5565 521.353 101.622 535.202C104.312 547.397 109.627 558.798 117.323 568.655C132.98 588.679 157.414 600.256 182.818 599.925C189.214 599.837 195.609 598.977 201.828 597.411C203.195 597.059 202.621 594.942 201.232 595.294C175.916 601.712 148.24 595.118 128.746 577.675C119.903 569.758 112.78 559.878 108.193 548.918C102.746 535.885 101.159 521.618 101.026 507.592C100.806 481.901 106.275 454.358 126.122 436.385C134.7 428.623 145.55 423.419 157.194 422.889C168.837 422.36 179.93 425.844 188.045 433.695C190.074 435.658 192.83 438.216 191.772 441.325C190.779 444.258 187.78 446.11 185.134 447.39C179.444 450.168 173.005 450.94 166.72 450.433C153.82 449.374 141.867 443.354 130.951 436.804C109.164 423.727 89.9561 406.857 68.5213 393.251C63.1405 389.833 57.6274 386.635 51.9379 383.791C46.2484 380.946 40.7133 378.432 34.8033 376.69C24.0858 373.514 10.9206 373.514 3.99617 383.791C-1.64922 392.148 -0.921491 403.902 3.73155 412.503C8.64922 421.588 17.2496 427.939 26.7983 431.49C48.7403 439.693 73.2625 433.585 92.7568 421.941C115.228 408.511 131.811 387.584 144.668 365.134C147.91 359.489 150.909 353.711 153.798 347.889C154.415 346.632 152.519 345.508 151.901 346.787L151.835 346.765Z"
              fill="#7055E6"
            />
            <path
              d="M1015.2 776.28C1017.67 662.6 925.758 670.826 901.919 608.837C884.256 562.858 889.085 500.052 804.735 460.358C757.08 437.931 737.343 398.744 712.534 336.932C687.725 275.119 657.955 263.541 618.261 240.32H419.172C379.478 263.519 349.707 275.119 324.899 336.932C300.09 398.744 280.331 437.931 232.698 460.358C148.348 500.052 153.177 562.858 135.513 608.837C111.697 670.848 19.7606 662.6 22.2305 776.28H1015.2Z"
              fill="#23184F"
            />
            <path
              d="M447.29 254.02C409.448 280.152 380.648 293.934 360.559 357.445C340.469 420.934 323.731 461.51 277.906 487.443C196.776 533.378 206.325 595.632 192.167 642.802C173.07 706.423 80.7808 705.122 91.8069 818.294"
              stroke="#4B34AB"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M470.135 266.566C435.028 296.271 407.705 312.81 393.922 377.975C380.14 443.139 367.437 485.149 324.369 515.449C248.134 569.08 263.703 630.121 254.243 678.46C241.475 743.646 149.494 751.365 171.525 862.927"
              stroke="#4B34AB"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M590.166 254.02C628.008 280.152 656.808 293.934 676.898 357.445C696.987 420.934 713.725 461.51 759.55 487.443C840.68 533.378 831.132 595.632 845.289 642.802C864.387 706.423 956.676 705.122 945.649 818.294"
              stroke="#4B34AB"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M567.319 266.566C602.427 296.271 629.749 312.81 643.532 377.975C657.315 443.139 670.017 485.149 713.085 515.449C789.32 569.08 773.751 630.121 783.212 678.46C795.98 743.646 887.96 751.365 865.93 862.927"
              stroke="#4B34AB"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M564.299 132.667C539.49 136.086 512.939 125.853 512.939 125.853C512.939 125.853 486.388 136.086 461.58 132.667C436.771 129.249 383.117 113.129 383.426 135.358C383.735 157.587 462.506 159.968 512.917 159.968C563.329 159.968 642.1 157.587 642.409 135.358C642.717 113.129 589.064 129.249 564.255 132.667H564.299Z"
              fill="#23184F"
            />
            <path
              d="M626.467 229.775C630.701 210.524 614.889 198.064 603.312 198.99C612.089 179.805 599.387 163.464 585.119 163.464C585.957 141.985 571.909 131.444 561.346 131.753H464.559C453.996 131.444 439.97 141.985 440.786 163.464C426.518 163.464 413.816 179.805 422.593 198.99C411.016 198.064 395.204 210.502 399.438 229.775C366.36 233.215 354.363 276.769 354.363 276.769L512.942 324.314L671.52 276.769C671.52 276.769 659.523 233.215 626.445 229.775H626.467Z"
              fill="#FFDBA8"
            />
            <path
              d="M512.963 223.446C477.062 211.626 432.472 204.305 432.472 204.305L512.963 274.938L593.454 204.305C593.454 204.305 548.864 211.648 512.963 223.446Z"
              fill="#23184F"
            />
            <path
              d="M533.207 213.105L512.963 215.178L492.697 213.105L489.323 246.03L512.963 271.191L536.581 246.03L533.207 213.105Z"
              fill="#FF8570"
            />
            <path
              d="M492.122 218.707C495.187 248.455 519.268 246.647 533.801 218.707L533.228 213.105L512.962 215.178L492.695 213.105L492.122 218.707Z"
              fill="#8A2323"
            />
            <path
              d="M546.724 156.65C542.247 150.982 536.646 142.051 535.521 131.73H490.358C489.255 142.051 483.654 150.982 479.155 156.65C475.539 161.214 473.885 166.992 474.657 172.748L476.134 183.509C473.334 203.356 488.836 221.042 512.918 221.042C536.999 221.042 552.501 203.356 549.701 183.509L551.178 172.748C551.972 166.992 550.296 161.192 546.68 156.65H546.724Z"
              fill="#FF8570"
            />
            <path
              opacity="0.4"
              d="M491.593 191.845C496.428 191.845 500.347 187.926 500.347 183.091C500.347 178.256 496.428 174.336 491.593 174.336C486.758 174.336 482.838 178.256 482.838 183.091C482.838 187.926 486.758 191.845 491.593 191.845Z"
              fill="#FA346F"
            />
            <path
              opacity="0.4"
              d="M534.308 191.845C539.143 191.845 543.062 187.926 543.062 183.091C543.062 178.256 539.143 174.336 534.308 174.336C529.472 174.336 525.553 178.256 525.553 183.091C525.553 187.926 529.472 191.845 534.308 191.845Z"
              fill="#FA346F"
            />
            <path
              d="M471.925 168.437L468.529 164.269C464.515 159.351 457.348 158.513 452.298 162.328C447.314 166.099 446.123 173.156 449.674 178.272C452.519 182.374 457.15 186.983 464.669 190.798C468.484 192.739 473.137 191.812 475.894 188.549C477.592 186.498 478.165 183.719 477.371 181.183L475.497 175.141C474.747 172.693 473.512 170.422 471.903 168.415L471.925 168.437Z"
              fill="#FF8570"
            />
            <path
              d="M454.372 170.685C456.004 165.811 462.443 167.311 466.942 171.611C471.441 175.911 474.021 183.144 469.412 185.416"
              stroke="#8A2323"
              stroke-width="2.30775"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M461.494 177.194L464.559 169.719"
              stroke="#8A2323"
              stroke-width="2.30775"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M466.807 199.663C469.73 199.663 472.1 197.294 472.1 194.371C472.1 191.448 469.73 189.078 466.807 189.078C463.884 189.078 461.515 191.448 461.515 194.371C461.515 197.294 463.884 199.663 466.807 199.663Z"
              fill="#23184F"
            />
            <path
              d="M554 168.437L557.396 164.269C561.41 159.351 568.577 158.513 573.627 162.328C578.61 166.099 579.801 173.156 576.251 178.272C573.406 182.374 568.775 186.983 561.255 190.798C557.44 192.739 552.787 191.812 550.031 188.549C548.333 186.498 547.759 183.719 548.553 181.183L550.428 175.141C551.177 172.693 552.412 170.422 554.022 168.415L554 168.437Z"
              fill="#FF8570"
            />
            <path
              d="M571.554 170.685C569.922 165.811 563.483 167.311 558.984 171.611C554.486 175.911 551.905 183.144 556.514 185.416"
              stroke="#8A2323"
              stroke-width="2.30775"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M564.409 177.194L561.344 169.719"
              stroke="#8A2323"
              stroke-width="2.30775"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M559.119 199.663C562.042 199.663 564.411 197.294 564.411 194.371C564.411 191.448 562.042 189.078 559.119 189.078C556.196 189.078 553.826 191.448 553.826 194.371C553.826 197.294 556.196 199.663 559.119 199.663Z"
              fill="#23184F"
            />
            <path
              d="M496.139 182.715C503.276 182.715 509.061 176.327 509.061 168.448C509.061 160.568 503.276 154.18 496.139 154.18C489.002 154.18 483.216 160.568 483.216 168.448C483.216 176.327 489.002 182.715 496.139 182.715Z"
              stroke="#23184F"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M529.767 182.715C536.904 182.715 542.69 176.327 542.69 168.448C542.69 160.568 536.904 154.18 529.767 154.18C522.63 154.18 516.845 160.568 516.845 168.448C516.845 176.327 522.63 182.715 529.767 182.715Z"
              stroke="#23184F"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M508.533 164.429C508.533 164.429 512.635 162.224 517.354 164.429"
              stroke="#23184F"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M483.877 163.945H472.101"
              stroke="#23184F"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M553.805 163.945H542.029"
              stroke="#23184F"
              stroke-width="2.30775"
              stroke-miterlimit="10"
            />
            <path
              d="M484.848 154.177C489.611 149.414 501.916 144.606 509.877 157.022"
              stroke="#FFDBA8"
              stroke-width="4.61549"
              stroke-miterlimit="10"
            />
            <path
              d="M517.374 155.834C519.579 149.417 529.613 138.787 537.971 146.109"
              stroke="#FFDBA8"
              stroke-width="4.61549"
              stroke-miterlimit="10"
              class="brow"
            />
            <path
              d="M501.099 172.766C503.535 172.766 505.509 170.792 505.509 168.356C505.509 165.92 503.535 163.945 501.099 163.945C498.663 163.945 496.688 165.92 496.688 168.356C496.688 170.792 498.663 172.766 501.099 172.766Z"
              fill="#23184F"
            />
            <path
              d="M534.177 172.766C536.613 172.766 538.588 170.792 538.588 168.356C538.588 165.92 536.613 163.945 534.177 163.945C531.741 163.945 529.767 165.92 529.767 168.356C529.767 170.792 531.741 172.766 534.177 172.766Z"
              fill="#23184F"
            />
            <path
              d="M522.865 188.557L520.549 195.261L519.16 189.263C517.153 189.549 515.08 189.748 512.963 189.748C510.846 189.748 508.751 189.572 506.766 189.263L505.377 195.261L503.062 188.557C501.805 188.248 500.548 187.896 499.379 187.477C499.82 200.333 505.73 210.521 512.963 210.521C520.196 210.521 526.128 200.333 526.547 187.477C525.379 187.896 524.122 188.248 522.865 188.557Z"
              fill="#23184F"
            />
            <path
              d="M512.963 198.066C508.884 198.066 505.223 199.544 502.599 201.904C505.091 207.174 508.795 210.526 512.963 210.526C517.131 210.526 520.814 207.174 523.328 201.904C520.726 199.544 517.043 198.066 512.963 198.066Z"
              fill="#8A2323"
            />
            <path
              d="M512.961 168.352L513.777 176.357C510.205 178.385 507.249 180.965 503.743 185.332C503.743 185.332 511.594 185.508 517.372 185.332"
              stroke="#8A2323"
              stroke-width="2.30775"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M630.676 442.164L619.143 240.341L571.841 232.534L594.092 204.285C594.092 204.285 547.208 222.611 512.961 262.305C478.714 222.611 431.831 204.285 431.831 204.285L454.081 232.534L406.404 246.802L395.246 442.164L326.398 692.104H699.524L630.676 442.164Z"
              fill="#7055E6"
            />
            <path
              d="M406.406 246.793L291.91 285.98L303.113 411.766L411.037 382.613L406.406 246.793Z"
              fill="#7055E6"
            />
            <path
              d="M619.144 240.336L757.103 265.189L614.05 384.69L619.144 240.336Z"
              fill="#7055E6"
            />
            <path
              d="M457.081 235.824L514.218 297.416L407.772 248.019C405.523 246.96 405.743 243.697 408.125 242.969L443.673 232.185C448.481 230.73 453.685 232.141 457.081 235.824Z"
              fill="#23184F"
            />
            <path
              d="M569.57 235.021L511.727 297.407L628.935 243.004C630.699 242.188 630.346 239.586 628.45 239.255L581.456 231.03C577.068 230.258 572.613 231.779 569.592 235.021H569.57Z"
              fill="#23184F"
            />
            <path
              d="M614.867 122.138C580.333 123.991 556.979 116.36 556.979 116.36L542.292 38.6922C541.631 35.1638 539.823 31.9662 537.088 29.6507C525.07 19.4625 512.081 10.1565 498.166 1.66632C494.329 -0.671221 489.499 -0.538921 485.794 1.9971C466.433 15.3167 448.195 30.6431 430.906 47.7116C428.458 50.1373 426.76 53.2687 426.143 56.6648C423.585 71.0209 422.769 85.3108 423.32 99.5565C423.386 101.431 425.856 102.048 426.805 100.439C434.17 87.9129 439.837 76.2693 444.116 66.1473C456.906 60.3255 468.902 52.8939 480.083 43.8303L485.861 57.8777L468.902 116.382C468.902 116.382 445.549 124.035 411.015 122.16C389.933 121.013 383.317 127.938 383.736 135.392C394.498 115.963 448.328 140.772 512.941 140.772C577.554 140.772 631.406 115.963 642.145 135.392C642.564 127.938 635.927 121.036 614.845 122.16L614.867 122.138Z"
              fill="#7055E6"
            />
            <path
              d="M555.964 110.939L552.282 91.4884C527.076 87.9821 501.451 87.8498 476.223 91.1356L470.512 110.85C498.783 106.219 527.693 106.263 555.964 110.939Z"
              fill="#23184F"
            />
            <path
              d="M493.82 91.8601L496.731 107.473C497.304 110.583 500.017 112.832 503.192 112.832H522.753C525.906 112.832 528.619 110.583 529.214 107.473L532.125 91.8601C532.875 87.8245 529.787 84.0977 525.664 84.0977H500.281C496.18 84.0977 493.07 87.8245 493.82 91.8601ZM520.195 105.643H505.728C504.361 105.643 503.214 104.606 503.06 103.239L502.244 95.8074C502.068 94.2197 503.325 92.8304 504.912 92.8304H521.011C522.62 92.8304 523.855 94.2197 523.679 95.8074L522.863 103.239C522.709 104.606 521.562 105.643 520.195 105.643Z"
              fill="#FCC40A"
            />
            <path
              d="M487.845 310.144C481.714 318.259 478.142 334.247 479.354 341.149C486.301 340.443 495.96 332.13 502.09 324.014C508.221 315.899 512.72 304.322 511.507 297.441C504.56 298.147 493.975 302.05 487.845 310.166V310.144Z"
              fill="#23184F"
            />
            <path
              d="M538.059 310.144C544.189 318.259 547.762 334.247 546.549 341.149C539.602 340.443 529.943 332.13 523.813 324.014C517.682 315.899 513.184 304.322 514.397 297.441C521.343 298.147 531.928 302.05 538.059 310.166V310.144Z"
              fill="#23184F"
            />
            <path
              d="M512.963 305.062C519.747 305.062 525.246 299.563 525.246 292.779C525.246 285.995 519.747 280.496 512.963 280.496C506.179 280.496 500.68 285.995 500.68 292.779C500.68 299.563 506.179 305.062 512.963 305.062Z"
              fill="#FFDBA8"
            />
            <path
              d="M617.338 271.191C605.341 292.075 608.671 328.263 619.102 343.655C596.675 339.223 593.367 286.297 617.338 271.191Z"
              fill="#4B34AB"
            />
            <path
              d="M513.337 925.001C694.283 925.001 840.969 910.29 840.969 892.143C840.969 873.996 694.283 859.285 513.337 859.285C332.392 859.285 185.706 873.996 185.706 892.143C185.706 910.29 332.392 925.001 513.337 925.001Z"
              fill="#23184F"
            />
            <path
              d="M292.31 788.929C237.355 763.327 200.616 726.499 179.446 700.103C152.211 666.142 154.218 616.965 184.099 585.695L185.422 584.306C204.387 564.723 230.828 555.307 257.952 558.438C285.098 561.57 308.694 576.764 322.698 600.117C334.275 619.435 339.215 633.416 339.435 634.012L310.282 644.2L324.859 639.106L310.304 644.222C310.26 644.112 306.048 632.38 296.235 615.995C287.193 600.933 271.955 591.12 254.424 589.091C236.892 587.062 219.846 593.149 207.607 605.763L206.416 606.998C187.164 627.153 185.929 658.865 203.505 680.785C222.602 704.601 255.769 737.856 305.32 760.923L292.288 788.907L292.31 788.929Z"
              fill="#D25BF0"
            />
            <path
              d="M305.344 760.94C281.219 749.693 260.997 736.043 244.369 722.238C243.994 732.89 244.7 743.85 246.839 755.03C247.435 758.139 248.118 761.183 248.846 764.182C261.835 773.025 276.279 781.471 292.311 788.924L305.344 760.94Z"
              fill="#23184F"
            />
            <path
              d="M309.687 583.422C306.445 586.73 298.683 594.977 289.575 607.084C292.045 609.796 294.272 612.774 296.213 616.015C306.026 632.4 310.238 644.132 310.282 644.242L324.837 639.126L339.413 634.032C339.215 633.437 334.275 619.455 322.676 600.138C318.971 593.963 314.583 588.384 309.665 583.422H309.687Z"
              fill="#23184F"
            />
            <path
              d="M734.37 788.929C789.324 763.327 826.063 726.499 847.234 700.103C874.468 666.142 872.462 616.965 842.581 585.695L841.258 584.306C822.293 564.723 795.852 555.307 768.727 558.438C741.581 561.57 717.985 576.764 703.982 600.117C692.404 619.435 687.465 633.416 687.244 634.012L716.397 644.2L701.821 639.106L716.375 644.222C716.419 644.112 720.631 632.38 730.445 615.995C739.486 600.933 754.724 591.12 772.256 589.091C789.787 587.062 806.834 593.149 819.073 605.763L820.264 606.998C839.515 627.153 840.75 658.865 823.175 680.785C804.077 704.601 770.911 737.856 721.359 760.923L734.392 788.907L734.37 788.929Z"
              fill="#D25BF0"
            />
            <path
              d="M721.338 760.94C745.463 749.693 765.685 736.043 782.313 722.238C782.687 732.89 781.982 743.85 779.843 755.03C779.247 758.139 778.564 761.183 777.836 764.182C764.847 773.025 750.403 781.471 734.371 788.924L721.338 760.94Z"
              fill="#23184F"
            />
            <path
              d="M716.971 583.422C720.212 586.73 727.975 594.977 737.082 607.084C734.612 609.796 732.385 612.774 730.445 616.015C720.631 632.4 716.419 644.132 716.375 644.242L701.821 639.126L687.244 634.032C687.443 633.437 692.382 619.455 703.982 600.138C707.687 593.963 712.075 588.384 716.993 583.422H716.971Z"
              fill="#23184F"
            />
            <path
              d="M700.849 598.462L690.308 557.863H336.368L325.827 598.462C325.827 598.462 249.746 671.234 266.396 758.054C272.107 787.847 284.501 812.259 299.54 831.996C335.155 878.702 391.234 905.253 449.959 905.253H576.672C635.397 905.253 691.498 878.725 727.091 831.996C742.153 812.237 754.524 787.847 760.235 758.054C776.885 671.234 700.805 598.462 700.805 598.462H700.849Z"
              fill="#D25BF0"
            />
            <path
              d="M336.369 557.844L327.681 591.319C363.317 601.485 414.964 607.88 472.41 607.88C579.959 607.88 667.154 585.475 667.154 557.844H336.369Z"
              fill="#23184F"
            />
            <path
              d="M516.426 598.468C623.98 598.468 711.17 576.066 711.17 548.431C711.17 520.797 623.98 498.395 516.426 498.395C408.872 498.395 321.682 520.797 321.682 548.431C321.682 576.066 408.872 598.468 516.426 598.468Z"
              fill="#D25BF0"
            />
            <path
              d="M516.426 584.424C611.619 584.424 688.787 568.311 688.787 548.435C688.787 528.558 611.619 512.445 516.426 512.445C421.234 512.445 344.065 528.558 344.065 548.435C344.065 568.311 421.234 584.424 516.426 584.424Z"
              fill="#23184F"
            />
            <path
              d="M350.085 557.85C369.91 573.155 436.861 584.423 516.448 584.423C596.034 584.423 662.963 573.155 682.81 557.85C662.985 542.546 596.034 531.277 516.448 531.277C436.861 531.277 369.932 542.546 350.085 557.85Z"
              fill="#FA346F"
            />
            <path
              opacity="0.3"
              d="M94.6811 97.8016C108.553 97.8016 119.799 86.5561 119.799 72.684C119.799 58.8119 108.553 47.5664 94.6811 47.5664C80.809 47.5664 69.5635 58.8119 69.5635 72.684C69.5635 86.5561 80.809 97.8016 94.6811 97.8016Z"
              fill="#FC7130"
              class="circle"
            />
            <path
              d="M60.4775 69.6442C73.0474 76.2379 81.4713 62.3228 91.9241 62.3008C101.098 62.3008 108.155 71.7612 98.7383 83.0079C95.9818 76.0173 86.0141 82.3022 79.0015 83.2064C68.9677 84.4854 61.1832 79.3472 60.4775 69.6442Z"
              fill="#FC7130"
            />
            <path
              opacity="0.4"
              d="M94.6796 77.3826C97.2737 77.3826 99.3767 75.2796 99.3767 72.6854C99.3767 70.0913 97.2737 67.9883 94.6796 67.9883C92.0854 67.9883 89.9824 70.0913 89.9824 72.6854C89.9824 75.2796 92.0854 77.3826 94.6796 77.3826Z"
              fill="#FFEEE6"
            />
            <path
              opacity="0.3"
              d="M34.81 168.098C48.682 168.098 59.9276 156.853 59.9276 142.981C59.9276 129.109 48.682 117.863 34.81 117.863C20.9379 117.863 9.69238 129.109 9.69238 142.981C9.69238 156.853 20.9379 168.098 34.81 168.098Z"
              fill="#FC7130"
              class="circle"
            />
            <path
              d="M0.606445 139.941C13.1763 146.535 21.6003 132.62 32.0531 132.598C41.2268 132.598 48.2836 142.058 38.8672 153.305C36.1107 146.314 26.143 152.599 19.1304 153.503C9.09659 154.782 1.31212 149.644 0.606445 139.941Z"
              fill="#FC7130"
            />
            <path
              opacity="0.4"
              d="M34.8085 147.679C37.4026 147.679 39.5056 145.576 39.5056 142.982C39.5056 140.388 37.4026 138.285 34.8085 138.285C32.2143 138.285 30.1113 140.388 30.1113 142.982C30.1113 145.576 32.2143 147.679 34.8085 147.679Z"
              fill="#FFEEE6"
            />
            <path
              opacity="0.3"
              d="M173.538 125.876C187.41 125.876 198.655 114.63 198.655 100.758C198.655 86.8862 187.41 75.6406 173.538 75.6406C159.665 75.6406 148.42 86.8862 148.42 100.758C148.42 114.63 159.665 125.876 173.538 125.876Z"
              fill="#FC7130"
              class="circle"
            />
            <path
              d="M139.313 97.7184C151.883 104.312 160.307 90.3971 170.76 90.375C179.934 90.375 186.991 99.8354 177.574 111.082C174.818 104.092 164.85 110.376 157.837 111.281C147.804 112.56 140.019 107.421 139.313 97.7184Z"
              fill="#FC7130"
            />
            <path
              opacity="0.4"
              d="M173.538 105.457C176.132 105.457 178.235 103.354 178.235 100.76C178.235 98.1655 176.132 96.0625 173.538 96.0625C170.944 96.0625 168.841 98.1655 168.841 100.76C168.841 103.354 170.944 105.457 173.538 105.457Z"
              fill="#FFEEE6"
            />
            <path
              d="M188.622 113.035L171.455 116.484L186.271 190.231L203.438 186.782L188.622 113.035Z"
              fill="#FFF8ED"
            />
            <path
              d="M203.465 186.765L186.308 190.206L186.176 189.566C185.889 188.177 186.772 186.854 188.161 186.479C192.417 185.288 196.254 181.054 198.239 175.409C198.768 173.909 200.951 174.085 201.26 175.651L203.487 186.765H203.465Z"
              fill="#FFDBA8"
            />
            <path
              d="M108.217 84.6058L91.0508 88.0547L110.819 186.449L127.986 183L108.217 84.6058Z"
              fill="#FFF8ED"
            />
            <path
              d="M128 182.976L110.844 186.417L110.711 185.777C110.425 184.388 111.307 183.065 112.696 182.69C116.952 181.499 120.789 177.265 122.774 171.619C123.303 170.12 125.486 170.296 125.795 171.862L128.022 182.976H128Z"
              fill="#FFDBA8"
            />
            <path
              d="M47.9155 156.246L30.749 159.695L42.6812 219.086L59.8477 215.637L47.9155 156.246Z"
              fill="#FFF8ED"
            />
            <path
              d="M59.8782 215.625L42.7215 219.065L42.5892 218.426C42.3025 217.036 43.1846 215.713 44.5739 215.338C48.83 214.147 52.6671 209.913 54.6518 204.268C55.1811 202.768 57.3642 202.945 57.673 204.51L59.9003 215.625H59.8782Z"
              fill="#FFDBA8"
            />
            <path
              d="M121.296 193.953L144.738 311.889"
              stroke="#23184F"
              stroke-width="4.43087"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M53.041 226.641L57.4735 248.715C62.9205 275.862 89.3612 293.46 116.508 287.991L162.002 278.839C189.148 273.392 206.746 246.951 201.277 219.805L196.844 197.73"
              stroke="#23184F"
              stroke-width="4.43087"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M131.219 314.632L158.222 309.207C162.503 308.347 166.683 311.128 167.544 315.409L168.816 321.744L126.289 330.288L125.016 323.953C124.156 319.672 126.938 315.492 131.219 314.632Z"
              fill="#23184F"
            />
            <path
              d="M201.037 311.17L92.5251 332.971C89.7191 333.535 87.9004 336.262 88.4629 339.062C89.0255 341.862 91.7563 343.675 94.5623 343.111L203.075 321.31C205.881 320.747 207.699 318.02 207.137 315.22C206.574 312.419 203.843 310.607 201.037 311.17Z"
              fill="#23184F"
            />
            <path
              d="M142.158 180.133L96.708 189.262L97.3255 192.394L103.61 191.137C106.389 199.627 114.703 204.942 123.149 203.244C131.595 201.546 137.196 193.43 136.49 184.521L142.775 183.264L142.158 180.133Z"
              fill="#23184F"
            />
            <path
              d="M74.0152 212.773L28.5654 221.903L29.1829 225.035L35.4678 223.778C38.2464 232.268 46.5601 237.582 55.0062 235.884C63.4522 234.186 69.0535 226.071 68.3478 217.162L74.6327 215.905L74.0152 212.773Z"
              fill="#23184F"
            />
            <path
              d="M217.598 183.93L172.148 193.059L172.766 196.191L179.051 194.934C181.829 203.424 190.143 208.739 198.589 207.041C207.035 205.342 212.636 197.227 211.931 188.318L218.216 187.061L217.598 183.93Z"
              fill="#23184F"
            />
            <g class="bubble-group">
              <path
                opacity="0.2"
                d="M515.387 548.016C496.114 548.016 479.508 550 471.9 552.867C468.063 551.61 462.219 550.794 455.67 550.794C444.136 550.794 434.786 553.308 434.786 556.396C434.786 559.483 444.136 561.997 455.67 561.997C462.219 561.997 468.063 561.181 471.9 559.924C479.508 562.791 496.114 564.775 515.387 564.775C541.872 564.775 563.329 561.026 563.329 556.418C563.329 551.809 541.872 548.06 515.387 548.06V548.016Z"
                fill="#FFEEE6"
                class="bubble"
              />
              <path
                opacity="0.2"
                d="M421.357 570.331C432.891 570.331 442.241 567.824 442.241 564.73C442.241 561.637 432.891 559.129 421.357 559.129C409.824 559.129 400.474 561.637 400.474 564.73C400.474 567.824 409.824 570.331 421.357 570.331Z"
                fill="#FFEEE6"
                class="bubble"
              />
              <path
                opacity="0.2"
                d="M608.514 574.875C622.91 574.875 634.58 571.755 634.58 567.906C634.58 564.057 622.91 560.938 608.514 560.938C594.118 560.938 582.448 564.057 582.448 567.906C582.448 571.755 594.118 574.875 608.514 574.875Z"
                fill="#FFEEE6"
                class="bubble"
              />
            </g>

            <path
              opacity="0.2"
              d="M582.25 554.433C589.448 554.433 595.283 552.873 595.283 550.949C595.283 549.025 589.448 547.465 582.25 547.465C575.052 547.465 569.217 549.025 569.217 550.949C569.217 552.873 575.052 554.433 582.25 554.433Z"
              fill="#FFEEE6"
            />
            <g class="animation">
              <path
                class="animation-arm"
                d="M657.494 442.979C691.864 442.979 719.726 415.117 719.726 380.747C719.726 346.378 691.864 318.516 657.494 318.516C623.125 318.516 595.263 346.378 595.263 380.747C595.263 415.117 623.125 442.979 657.494 442.979Z"
                fill="#FFEEE6"
              />
              <path
                d="M553.43 393.844L561.699 423.417L569.638 421.189C573.056 417.617 574.335 411.111 572.483 404.452C570.608 397.792 566.132 392.896 561.369 391.617L553.43 393.844Z"
                fill="#A696EB"
              />
              <path
                d="M566.129 425.647C570.456 424.436 571.713 415.41 568.935 405.488C566.157 395.566 560.397 388.505 556.069 389.716C551.742 390.928 550.485 399.954 553.263 409.876C556.041 419.798 561.801 426.859 566.129 425.647Z"
                fill="#FFEEE6"
              />
              <path
                class="animation-arm"
                d="M553.475 393.897L561.751 423.457L623.59 406.145L615.314 376.585L553.475 393.897Z"
                fill="#FFEEE6"
              />
            </g>

            <path
              d="M626.466 389.349C628.252 395.722 627.789 401.831 625.606 405.536C630.921 403.485 633.435 395.877 631.229 388.026C629.024 380.175 622.916 374.971 617.314 375.985C621.085 378.036 624.658 382.998 626.444 389.371L626.466 389.349Z"
              stroke="#23184F"
              stroke-width="1.59235"
              stroke-miterlimit="10"
            />

            <path
              d="M717.829 504.193C708.148 515.903 622.1 370.402 622.1 370.402L650.194 344.711C650.194 344.711 733.662 485.03 717.807 504.193H717.829Z"
              fill="#4B34AB"
            />
            <path
              class="animation"
              d="M636.061 332.281L605.254 362.471C592.751 359.472 580.908 374.975 579.078 386.662L582.011 385.846C586.377 384.633 590.788 387.611 591.273 392.109L591.957 398.416C592.221 400.842 591.935 403.29 591.097 405.605L588.869 411.824C587.877 414.603 585.584 416.742 582.739 417.536L582.011 417.734C582.011 417.734 588.649 426.246 597.933 415.286C601.439 418.594 607.107 416.653 610.966 412.596C615.729 413.632 620.095 413.676 623.778 409.089C630.394 408.67 633.834 405.274 636.083 401.239C638.333 397.203 638.267 379.12 638.267 379.12L653.152 364.434L636.083 332.281H636.061Z"
              fill="#FF8570"
            />
            <g class="animation">
              <path
                d="M599.676 412.285L602.454 406.551C604.395 402.538 605.762 398.26 606.49 393.871"
                stroke="#8A2323"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M612.62 409.728L614.428 406.001C616.545 401.613 618.111 396.982 619.081 392.219"
                stroke="#8A2323"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M625.52 406.091L627.438 402.475C629.224 399.123 630.592 395.594 631.54 391.934"
                stroke="#8A2323"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                class="animation-arm"
                d="M565.736 406.35C563.729 399.227 560.046 394.022 557.51 394.728C557.091 394.838 556.716 395.147 556.408 395.566C518.345 423.617 486.259 492.221 484.892 551.763C484.804 555.115 487.23 558.092 490.537 558.643C494.352 559.283 498.895 557.981 504.276 555.688C511.046 559.305 518.588 560.385 524.542 555.688C528.997 559.216 535.127 559.878 540.331 557.695C542.426 556.813 543.772 554.674 543.772 552.402C544.036 472.771 553.585 434.003 564.743 420.573C567.301 419.868 567.743 413.495 565.736 406.372V406.35Z"
                fill="#FA769D"
              />
              <path
                opacity="0.4"
                d="M504.321 540.494C506.769 473.962 537.598 422.867 559.562 403.086"
                stroke="#FFEEE6"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.4"
                d="M524.805 540.497C526.745 485.829 539.139 435.307 561.125 413.145"
                stroke="#FFEEE6"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>

            <path
              d="M617.358 351.198C615.462 350.382 713.22 257.277 713.22 257.277L756.773 265.304C778.892 269.384 794.659 289.452 792.829 311.879C791.373 329.719 785.331 351.507 768.703 373.096C786.477 412.371 753.002 435.945 743.079 442.98C744.732 466.951 732.736 495.905 717.851 504.175C714.962 465.319 650.04 365.245 617.38 351.198H617.358Z"
              fill="#7055E6"
            />

            <g>
              <path
                d="M461.979 556.88L346.711 113.738L332.929 117.333L447.27 556.88C451.945 559.614 456.863 559.372 461.979 556.88Z"
                fill="#FFF8ED"
                class="bar"
              />
              <path
                d="M346.711 113.738L332.929 117.333L338.684 139.495C343.778 137.18 347.88 133.431 350.615 128.822L346.689 113.76L346.711 113.738Z"
                fill="#A696EB"
                class="bar"
              />
              <path
                d="M337.603 133.717C352.365 133.717 364.331 121.75 364.331 106.989C364.331 92.228 352.365 80.2617 337.603 80.2617C322.842 80.2617 310.876 92.228 310.876 106.989C310.876 121.75 322.842 133.717 337.603 133.717Z"
                fill="#FFF8ED"
                class="bar"
              />
            </g>
            <path
              d="M364.508 434.121C378.136 432.688 362.236 256.953 362.236 256.953L322.542 271.221C322.542 271.221 334.935 437.231 364.508 434.121Z"
              fill="#4B34AB"
            />
            <path
              d="M339.08 246.807C339.08 246.807 340.933 434.737 364.507 434.12C364.507 434.12 349.467 441.198 330.965 433.679C324.283 430.966 317.006 430.172 309.971 431.76C297.335 434.605 285.295 431.121 275.989 424.703C269.219 420.028 261.081 417.536 252.944 418.617C232.215 421.373 205.002 413.964 202.003 380.731C196.424 318.742 339.08 246.785 339.08 246.785V246.807Z"
              fill="#7055E6"
            />
            <path
              d="M324.172 301.188C324.172 301.188 324.988 398.35 341.527 428.121C321.261 408.274 318.372 335.92 324.172 301.188Z"
              fill="#4B34AB"
            />
            <path
              d="M269.086 407.528C269.086 407.528 246.438 384.284 246.019 351.625C233.626 378.507 246.262 405.543 269.086 407.528Z"
              fill="#4B34AB"
            />

            <g class="bar">
              <path
                d="M339.081 246.804C339.081 246.804 339.081 219.526 353.547 210.22C368.013 200.914 382.281 206.096 382.7 217.453C388.081 221.577 390.352 225.325 388.698 231.632C392.006 235.866 393.859 239.373 392.205 244.754C395.888 250.421 393.352 259.749 385.898 263.674L383.626 254.545C383.626 254.545 368.521 270.003 353.944 266.674L339.875 281.14C339.875 281.14 338.618 253.42 339.059 246.826L339.081 246.804Z"
                fill="#FF8570"
                class="bar"
              />
              <path
                d="M390.461 243.252C385.565 239.768 377.538 238.357 371.65 241.29"
                stroke="#8A2323"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M387.066 230.021C382.788 227.044 374.121 227.463 369.071 230.153"
                stroke="#8A2323"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M380.671 215.725C374.563 211.38 367.065 213.078 362.346 217.445"
                stroke="#8A2323"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>

            <g class="book">
              <path
                d="M874.665 200.792C874.665 200.792 904.436 145.286 988.786 164.318L979.568 188.906L874.665 200.814V200.792Z"
                fill="#FFF8ED"
              />
              <path
                d="M874.665 200.793C874.665 200.793 874.665 155.63 826.371 118.516L793.932 206.791L874.665 200.793Z"
                fill="#FFF8ED"
              />
              <path
                d="M703.671 295.896L769.232 150.769C769.232 150.769 843.659 131.341 874.664 200.806C874.664 200.806 922.209 152.071 994.982 178.313L938.329 309.502C938.329 309.502 868.049 286.7 821.54 331.047C821.54 331.047 786.168 283.921 703.648 295.896H703.671Z"
                fill="#FFDBA8"
              />
              <path
                d="M850.275 313.541C850.275 313.541 840.903 337.886 850.275 375.111L858.346 356.917L872.349 368.076C872.349 368.076 860.882 339.43 868.733 312.195L850.275 313.541Z"
                fill="#FFDBA8"
              />
              <path
                d="M807.449 336.966L865.336 206.791C865.336 206.791 827.494 152.41 761.536 186.194L703.648 316.369C703.648 316.369 757.61 292.862 807.449 336.966Z"
                fill="#216B57"
              />
              <path
                d="M802.202 316.237C783.038 303.513 761.405 296.875 738.779 296.875C734.435 296.875 730.333 297.118 726.54 297.514L771.703 195.964C782.707 190.914 793.425 188.355 803.591 188.355C826.68 188.355 842.579 201.366 849.923 208.974L802.224 316.237H802.202Z"
                stroke="#FCAB0A"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M937.074 336.967L994.961 206.792C994.961 206.792 952.422 172.986 886.464 206.748L828.576 336.923C828.576 336.923 887.235 292.862 937.074 336.967Z"
                fill="#216B57"
              />
              <path
                d="M942.668 268.792C956.491 243.438 957.191 217.157 944.231 210.091C931.271 203.025 909.559 217.85 895.736 243.203C881.913 268.556 881.213 294.838 894.173 301.904C907.133 308.97 928.845 294.145 942.668 268.792Z"
                stroke="#FCAB0A"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M937.072 336.961L948.076 312.219L921.966 326.266C927.038 329.045 932.11 332.551 937.072 336.961Z"
                fill="#23184F"
              />
              <path
                d="M752.383 206.788L781.448 178.297C775.141 180.061 768.503 182.641 761.557 186.192L752.383 206.788Z"
                fill="#23184F"
              />
              <path
                d="M828.551 336.964H807.447L865.357 206.789H886.439L828.551 336.964Z"
                fill="#2C8F74"
              />
              <path
                d="M872.347 238.463H851.265L856.182 227.371H877.264L872.347 238.463Z"
                fill="#4B34AB"
              />
              <path
                d="M842.09 230.573L851.264 238.468L856.181 227.375L844.692 224.707L842.09 230.573Z"
                fill="#23184F"
              />
              <path
                d="M881.586 233.237L872.346 238.463L877.263 227.371H884.188L881.586 233.237Z"
                fill="#23184F"
              />
              <path
                d="M837.704 316.336H816.622L821.54 305.266H842.644L837.704 316.336Z"
                fill="#4B34AB"
              />
              <path
                d="M807.447 308.467L816.621 316.34L821.539 305.27L810.049 302.602L807.447 308.467Z"
                fill="#23184F"
              />
              <path
                d="M846.943 311.132L837.703 316.336L842.643 305.266H849.545L846.943 311.132Z"
                fill="#23184F"
              />
              <path
                d="M722.326 311.43L716.857 286.688L703.67 316.37C703.67 316.37 710.837 313.261 722.326 311.43Z"
                fill="#23184F"
              />
              <path
                d="M994.984 206.783C994.984 206.783 988.588 201.733 976.967 197.477L984.641 230.07L994.984 206.805V206.783Z"
                fill="#23184F"
              />
              <path
                d="M871.487 201.04C871.487 201.04 851.266 148.269 769.518 160.353"
                stroke="#FCAB0A"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M765.813 173.292C801.582 158.539 853.273 173.91 867.739 203.063"
                stroke="#FCAB0A"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M878.899 201.034C897.291 186.942 934.758 171.903 987.86 183.634"
                stroke="#FCAB0A"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M882.404 203.065C892.747 196.869 939.432 178.257 985.962 193.34"
                stroke="#FCAB0A"
                stroke-width="2.30775"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>

            <path
              d="M622.12 345.952L696.723 273.047C696.723 273.047 641.372 296.444 622.12 345.952Z"
              fill="#4B34AB"
            />
            <path
              d="M738.888 434.316C738.888 434.316 733.772 369.394 703.671 352.039C738.492 358.655 744.688 409.088 738.888 434.316Z"
              fill="#4B34AB"
            />
            <g class="sparkle">
              <path
                d="M471.262 463.254L476.819 469.693L485.287 468.745L480.877 476.022L484.383 483.785L476.114 481.844L469.807 487.578L469.079 479.11L461.691 474.898L469.542 471.59L471.262 463.254Z"
                fill="#FCC40A"
              />
              <path
                d="M566.815 444.129L570.344 448.187L575.658 447.591L572.902 452.178L575.107 457.074L569.881 455.861L565.911 459.477L565.448 454.119L560.795 451.472L565.735 449.377L566.815 444.129Z"
                fill="#FCC40A"
              />
              <path
                d="M575.348 495.625L574.378 504.733L581.303 510.687L572.349 512.583L568.821 521.007L564.278 513.068L555.148 512.319L561.301 505.549L559.184 496.639L567.542 500.388L575.348 495.625Z"
                fill="#FCC40A"
              />
              <path
                d="M504.98 408.848L505.774 419.984L515.411 425.652L505.047 429.841L502.643 440.757L495.454 432.201L484.317 433.282L490.227 423.799L485.773 413.567L496.623 416.257L504.98 408.848Z"
                fill="#FCC40A"
              />
            </g>
          </svg>
        </div>
        <div class={`tree-left ${isBackgroundImageChanged ? "none" : ""}`}>
          <img src="/images/utils/loading/tree-left.svg" alt="" />
        </div>
        <div class={`tree-right ${isBackgroundImageChanged ? "none" : ""}`}>
          <img src="../images/utils/loading/tree-right.svg" alt="" />
        </div>
        {showOngoingModal && (
          <OngoingModal onClose={() => setShowOngoingModal(false)} />
        )}
      </section>
    </>
  );
};

export default Loading;
